module.exports = __webpack_public_path__ + "img/cs3.ce425bc7.png";